import { useState, useEffect } from 'react';
import styled from '@emotion/styled';

import { Grid, Paper, Divider, Button, IconButton, lighten, darken } from '@mui/material';

import CloseRounded from '@mui/icons-material/CloseRounded';
import AddRounded from '@mui/icons-material/AddRounded';

import { BasicFlex, InputLabel } from '../../../utils/Common';

import Field from '../../../utils/FormikFields/Field';
import AutoCompleteSoloFormik from '../../../utils/FormikFields/AutoCompleteSolo';

import { displayLabelCustomer, displayLabelWig } from '../../../utils/displayLabels';

import { useFormikContext } from 'formik';

import { useQuery } from "@tanstack/react-query";

import { getSoldInventoryByCustomer } from '../../Inventory/apiService';
import { getServicesByStylist } from '../../Schedule/apiService';

const IconBox = styled(BasicFlex)`
  width: fit-content;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
  padding: .5rem;
  border-radius: 4px;
  background-color: ${props => props.theme.colors.primaryFaint};
`

const Title = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
`

const SubHeader = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  color: ${props => props.theme.colors.lightText};
`

const TopBar = styled(BasicFlex)`
  margin-bottom: 2rem;
`

const Collapsed = ({ toggleOpen, width = "45rem", margin = "1rem 0" }) => {
  return (
    <Paper onClick={toggleOpen} elevation={4} sx={{cursor: "pointer", padding: "1.6rem", margin, width}}>
      <BasicFlex>
        <IconBox>
          <AddRounded />
        </IconBox>

        <BasicFlex dir="column">
          <Title>Schedule New Pickup</Title>
          <SubHeader>Click to add a customer pickup</SubHeader>
        </BasicFlex>

      </BasicFlex>
    </Paper>
  )
}

const Pickup = ({ width = "45rem", margin = "1rem 0"}) => {

  const [expand, setExpand] = useState(false);

  const { values } = useFormikContext();

  let stylist = values?.stylist_id

  const { data: customerWigs} = useQuery({
    queryKey: ['inventory', values?.customer_id],
    queryFn: () => getSoldInventoryByCustomer(values?.customer_id),
    enabled: !!values?.customer_id
  })

  const { data: services } = useQuery({
    queryKey: ["services", "stylists", stylist],
    queryFn: () => getServicesByStylist(stylist)
  });


  const toggleOpen = () => setExpand(x => !x)

  return ( expand ?
    <Paper elevation={4} sx={{padding: "1.6rem", margin, width}}>
      <TopBar>
        <Title>Schedule New Pickup</Title>
        <IconButton size="small" onClick={toggleOpen}>
          <CloseRounded />
        </IconButton>
      </TopBar>
      <Grid container spacing={2}>
        <Grid size={{xs: 12}}>
          <InputLabel>Customer *</InputLabel>
          <AutoCompleteSoloFormik 
            name="customer_id" 
            fieldName="customer_id"
            url="customers" 
            displayField="full_name"
            displayLabel={displayLabelCustomer} 
            formUpdates={[{name: "client_name", field: "full_name"}]}
          />
        </Grid>
        <Grid size={{xs: 12}}>
          <Field name="scheduled_pickup_date" label="Date" formFieldType="date" />
        </Grid>
        <Grid size={{xs: 12}}>
          <Divider />
        </Grid>
        <Grid size={{xs: 12}}>
          <InputLabel>Select Stylist *</InputLabel>
          <AutoCompleteSoloFormik 
            name="stylist_id"
            size="small" 
            fullWidth 
            fieldName="stylist_id"
            displayField="full_name"
            url="stylists"
          />
        </Grid>
        <Grid size={{xs: 12}}>
          <InputLabel>Select Service *</InputLabel>
          <AutoCompleteSoloFormik 
            name="service_name"
            size="small" 
            fullWidth 
            fieldName="name"
            url="services"
            serverOptions={services}
            formUpdates={[{name: "service_price", field: "service_price"}, {name: "total", field: "service_price"}]} 
            simple={true} 
          />
        </Grid>
        <Grid size={{xs: 12}}>
          <InputLabel>Add Wig ID</InputLabel>
          <AutoCompleteSoloFormik 
            name="wig_id"
            size="small" 
            fullWidth 
            fieldName="wig_id"
            serverOptions={customerWigs} 
            displayLabel={displayLabelWig} 
            formUpdates={[{name: "inventory_id", field: "inventory_id"}]}
            simple={true} 
          />
        </Grid>

        <Grid size={{xs: 12}}>
          <Field name="is_checked_in" label="Wig Checked In" formFieldType="switch" type="checkbox" />
        </Grid>

        <Grid size={{xs: 12}}>
          <Button variant="contained" color="primary" fullWidth type="submit">Schedule Pickup</Button>
        </Grid>
      </Grid>
    </Paper> : 
    <Collapsed toggleOpen={toggleOpen} width={width} margin={margin} />
  );
};

export default Pickup;